import React, {Component} from 'react';
import logoOrange from '../img/logo-orange.png';
import menuImg from '../img/menu.png';
import orderImg from '../img/orders.png';
import salesImg from '../img/sales.png';

import firebase from '../firebase.js';

export default class SideBar extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    logout() {
        let app = this;
        firebase.auth().signOut().then(function() {

        }, function(error) {
            console.error('Sign Out Error', error);
        });
    }

    render() {
        return (
            <div className="sidebar">
                <ul>
                    <li className="logo-item"><img alt="Fácil Logo" src={logoOrange}/></li>
                    <li className="hotel-name-item">{this.props.hotel.hotelName}</li>
                    <li><img alt="menus" src={menuImg}/>Menu Items</li>
                    <li><img alt="orders" src={orderImg}/>Order Management</li>
                    <li><img alt="sales" src={salesImg}/>Sales</li>
                    <li onClick={this.logout.bind(this)} ><img alt="Logout" src={salesImg}/>Logout</li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar.js